import React from 'react'
import { useSelector } from 'react-redux'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'
import { useParams } from 'react-router'
import { useFetchSubmissionVersionsQuery } from '../../../../../store/apis/submission.api'
import { DEFAULT_SUBMISSION_VERSION } from '../../../../../store/slices/submission.slice'
import submissionApiSelectors from '../../../../../store/apis/utils/selectors/submission.api.selectors'
import Paragraph from 'antd/es/typography/Paragraph'

const SubmissionUnitTestResultsSimplified = () => {
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)
    const selectedVersionId = useSelector(submissionSelectors.selectedVersionId)

    const { token, layerId } = useParams()

    const { data: submissionVersion } = useFetchSubmissionVersionsQuery(
        { token, layerId, submissionId: openedSubmissionId },
        {
            skip: selectedVersionId === DEFAULT_SUBMISSION_VERSION,
            selectFromResult: result => submissionApiSelectors.selectVersionById({ id: selectedVersionId }, result),
        },
    )

    const totalTestsCount = submissionVersion?.passedUnitTestsCount + submissionVersion?.failedUnitTestsCount
    return totalTestsCount ? (
        <Paragraph>
            Passed {submissionVersion?.passedUnitTestsCount}/{totalTestsCount} unit tests
        </Paragraph>
    ) : null
}

export default SubmissionUnitTestResultsSimplified
